<template>
  <div>{{ zueri9Reason }}</div>
</template>
<script>
import wsMixin from "@/modules/customerVbzWorksheet/wsMixin";

export default {
  name:'Zueri9Reason',
  mixins: [wsMixin],
  props: {
    column:Object,
    absence:Object,
    isAssignedToDifferentView:Boolean,
  },
  computed: {

    zueri9Reason() {
      return this.mx_zueri9Reason(this.absence);
    },
  },
}
</script>